
import { computed, defineComponent, reactive, toRefs, onMounted, onUnmounted } from 'vue'
export default defineComponent({
  name: 'layoutTagsViewContextmenu',
  props: {
    dropdown: {
      type: Object
    }
  },
  setup (props, { emit }) {
    const state = reactive({
      isShow: false,
      dropdownList: [
        { contextMenuClickId: 0, txt: 'message.tagsView.refresh', affix: false, icon: 'el-icon-refresh-right' },
        { contextMenuClickId: 1, txt: 'message.tagsView.close', affix: false, icon: 'el-icon-close' },
        { contextMenuClickId: 2, txt: 'message.tagsView.closeOther', affix: false, icon: 'el-icon-circle-close' },
        { contextMenuClickId: 3, txt: 'message.tagsView.closeAll', affix: false, icon: 'el-icon-folder-delete' },
        {
          contextMenuClickId: 4,
          txt: 'message.tagsView.fullscreen',
          affix: false,
          icon: 'iconfont icon-fullscreen'
        }
      ],
      item: {}
    })
    // 父级传过来的坐标 x,y 值
    const dropdowns = computed(() => {
      return props.dropdown
    })
    // 当前项菜单点击
    const onCurrentContextmenuClick = (contextMenuClickId: number) => {
      emit('currentContextmenuClick', Object.assign({}, { contextMenuClickId }, state.item))
    }
    // 打开右键菜单：判断是否固定，固定则不显示关闭按钮
    const openContextmenu = (item: any) => {
      state.item = item
      item.meta.isAffix ? (state.dropdownList[1].affix = true) : (state.dropdownList[1].affix = false)
      closeContextmenu()
      setTimeout(() => {
        state.isShow = true
      }, 10)
    }
    // 关闭右键菜单
    const closeContextmenu = () => {
      state.isShow = false
    }
    // 监听页面监听进行右键菜单的关闭
    onMounted(() => {
      document.body.addEventListener('click', closeContextmenu)
    })
    // 页面卸载时，移除右键菜单监听事件
    onUnmounted(() => {
      document.body.removeEventListener('click', closeContextmenu)
    })
    return {
      dropdowns,
      openContextmenu,
      closeContextmenu,
      onCurrentContextmenuClick,
      ...toRefs(state)
    }
  }
})
